import { render, staticRenderFns } from "./perfect_data.vue?vue&type=template&id=7a7247dc&scoped=true"
import script from "./perfect_data.vue?vue&type=script&lang=js"
export * from "./perfect_data.vue?vue&type=script&lang=js"
import style0 from "./perfect_data.vue?vue&type=style&index=0&id=7a7247dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7247dc",
  null
  
)

export default component.exports